import { render, staticRenderFns } from "./BauberatungenLayout.vue?vue&type=template&id=65f2c1cd&scoped=true"
import script from "./BauberatungenLayout.vue?vue&type=script&lang=js"
export * from "./BauberatungenLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f2c1cd",
  null
  
)

export default component.exports